export default __webpack_public_path__ + "static/media/edit.93b5d770.svg";